import type { KnowledgeArticle } from "../types"

export const ragChatbotLatenBouwen: KnowledgeArticle = {
  id: "insight:rag-chatbot-laten-bouwen",
  pageType: "knowledge-article",
  slug: { nl: "rag-chatbot-laten-bouwen" },
  title: {
    nl: "RAG Chatbot Laten Bouwen | Zo werkt Retrieval-Augmented Generation",
    en: "RAG Chatbot Laten Bouwen | Zo werkt Retrieval-Augmented Generation",
  },
  description: {
    nl: "Wat is een RAG-chatbot, waarom is hij nauwkeuriger dan een gewone chatbot en waar let je op bij het laten bouwen van een RAG-systeem op je eigen documentatie?",
    en: "What is a RAG chatbot, why is it more accurate than an ordinary chatbot, and what should you look at when building a RAG system on your own documentation?",
  },
  h1: {
    nl: "RAG chatbot laten bouwen",
    en: "RAG chatbot laten bouwen",
  },
  published: "2026-08-26",
  modified: "2026-08-26",
  author: "Camiel Schmeitz",
  sections: [
    {
      type: "paragraph",
      text: "Een RAG-chatbot (Retrieval-Augmented Generation) beantwoordt vragen op basis van jouw eigen documentatie in plaats van op de algemene kennis van het onderliggende taalmodel. Dat maakt hem geschikt voor alles waarin feitelijke juistheid telt: klantenservice, medewerkersondersteuning en kennisdeling binnen organisaties.",
    },
    {
      type: "heading",
      text: "Hoe werkt RAG technisch?",
    },
    {
      type: "paragraph",
      text: "In plaats van het taalmodel direct de vraag te stellen, doorloopt een RAG-systeem drie stappen. Eerst wordt de vraag geïnterpreteerd en omgezet in een zoekopdracht. Vervolgens haalt een retriever de meest relevante passages op uit een geïndexeerde kennisbank van jouw documenten. Tot slot genereert het taalmodel een antwoord op basis van die passages. Het model 'hallucineert' hierdoor veel minder, omdat het antwoord gestoeld is op gevonden bronnen in plaats van op herinnering.",
    },
    {
      type: "heading",
      text: "Waarom geen gewone chatbot met een lange prompt?",
    },
    {
      type: "list",
      items: [
        "Schaal: een kennisbank kan duizenden pagina's beslaan; die passen niet in een prompt.",
        "Actualiteit: documentatie wijzigt; een geïndexeerde kennisbank update je, een geprompte tekst vergeet je bij te werken.",
        "Verifieerbaarheid: bij RAG kun je terugverwijzen naar de bronpassage, bij vrije generatie niet.",
      ],
    },
    {
      type: "heading",
      text: "Uit de praktijk: Burgerkracht",
    },
    {
      type: "paragraph",
      text: "Voor het communityplatform Burgerkracht bouwden wij een conversationele assistent die natuurlijke gesprekken voert, de situatie van de gebruiker begrijpt en vervolgens automatisch doorverwijst naar de meest relevante groepen of pagina's. De combinatie van moderne taalmodellen met een kennisbank-gebaseerde retrievalarchitectuur zorgt ervoor dat bezoekers relevante informatie krijgen in plaats van een willekeurige zoeklijst.",
    },
    {
      type: "heading",
      text: "Waar valt of staat de kwaliteit?",
    },
    {
      type: "list",
      items: [
        "Bronmateriaal: rommelige, tegenstrijdige of verouderde documentatie levert rommelige antwoorden op.",
        "Indexering: hoe documenten gesplitst en geïndexeerd worden bepaalt welke passages gevonden kunnen worden.",
        "Evaluaties: test met realistische vragen uit de praktijk, inclusief lastige formuleringen en spreektaal.",
        "Grenzen: definieer wat de chatbot níet antwoordt, bijvoorbeeld over privacygevoelige of juridische kwesties.",
      ],
    },
    {
      type: "callout",
      title: "Vuistregel",
      text: "De kwaliteit van een RAG-chatbot is maximaal de kwaliteit van de kennisbank. Investeer eerst in het opruimen en structureren van documentatie, dan pas in het bouwen van de interface.",
    },
    {
      type: "heading",
      text: "Wat kost een RAG-chatbot?",
    },
    {
      type: "paragraph",
      text: "Dat hangt vooral af van de omvang en staat van de documentatie en van het aantal integraties. Een schaalbaar prototype is vaak binnen enkele weken haalbaar; productierijping vergt daarna vooral evaluatie en bijstelling. Belangrijk bij budgetteren: rekening houden met doorlopende kosten van modelgebruik en kennisbankonderhoud, niet alleen met de bouw.",
    },
  ],
  relatedServiceIds: ["ai-knowledge-systems", "ai-agents"],
  relatedCaseIds: ["burgerkracht"],
}
